import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material";
import { BaseDialog } from "../../base-dialog";

const MAX_WEIGHT = 50;

@Component({
  selector: "mandae-freight-cost-simulation-dialog",
  templateUrl: "./freight-cost-simulation-dialog.component.html",
  styleUrls: ["./freight-cost-simulation-dialog.component.scss"]
})
export class FreightCostSimulationDialogComponent extends BaseDialog<
  FreightCostSimulationDialogComponent
> {
  public readonly weights: number[];
  public readonly maxDimension = 120;

  public weight: number;
  public width: number;
  public length: number;
  public height: number;

  constructor(dialogRef: MatDialogRef<FreightCostSimulationDialogComponent>) {
    super(dialogRef);

    this.weights = Array(MAX_WEIGHT)
      .fill(0)
      .map((_, i) => i + 1);
    this.weights.unshift(0.3);
  }

  public handleFormSubmit() {
    this.accept({
      height: +this.height,
      length: +this.length,
      weight: +this.weight,
      width: +this.width
    });
  }
}
